import loadGoogleMaps from 'Lib/googleMapsLoader';

const maps = document.querySelectorAll('.map');

if (maps.length) {
  loadGoogleMaps()
    .then(() => import('CoreComponents/map'))
    .then(({ default: Map }) => {
      maps.forEach((map) => new Map(map));
    });
}
